import 'babel-polyfill';
/* eslint-disable */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import BootstrapVue from "bootstrap-vue";
import Vuetify from 'vuetify';
require('es6-promise').polyfill();
import axios from 'axios';
import VueAxios from 'vue-axios';
import Vuelidate from 'vuelidate';
import VueI18n from 'vue-i18n';
import VueSession from 'vue-session';
import Auth from './scripts/auth.js';
import VueMeta from 'vue-meta';


import { createPinia, PiniaVuePlugin } from 'pinia'
import { useSessionStore } from './session';

Vue.use(PiniaVuePlugin)
const pinia = createPinia()


const moment = require('moment')

require('moment/locale/es')
 
Vue.use(require('vue-moment'), {
    moment
})
var options = {
    persist: true
};
Vue.use(VueSession, options);
Vue.use(VueI18n);
Vue.use(Auth);
Vue.use(VueMeta);

const messages = {
    en: {
      master: {
        language: 'English',
        logo: '',
        legal: 'Legal',
        privacy: 'Privacy',
        copyright: ` 2024, 3M. ALL RIGHTS RESERVED.`,
        copyrightlegal: '3M’s use of information received while using this program will be treated in accordance with the privacy policy posted on our application at www.3M.ca/privacy. Usage of this program shall be considered acceptance of the Terms & Conditions.',
        trademark: '3M and 3M Science. Applied to Life. are trademarks of 3M. Used under license in Canada. © 2023, 3M. All rights reserved. ',
        okay:'Okay',
        cancel:'Cancel',
        checkforupdates: 'Check for updates',
        language: 'Language',
        logout: 'Log out',
        close: 'Close', 
        returnhome: 'Return to home',
        terms: `<p>Carefully read these Terms of Use before using this application. Your access to, and use of, the application and its materials is conditioned upon your acceptance and compliance with these terms in full. If you do not accept these terms, you should leave the application immediately and cease any further use of any materials you have obtained from the application.</p>
        <h4>Copyright and usage of content</h4>
        <p>The copyrights and other rights to the materials on this application are owned by 3M and/or its subsidiaries worldwide. You are authorized to view, download and reproduce the materials on this application only for your internal information provided that you 1) retain all notices contained in the original materials 2) only use images with surrounding text relating to the images, and 3) include the following copyright notice:</p>
        <ul>
        <li>&copy; 2024, 3M. All rights reserved.</li>
        </ul>
        <p>No further publication or commercial use may be made of the materials on this application without the express written permission of 3M.You may not make any part of this application available as part of another application whether by hyperlink framing on the internet or otherwise. <br />This application and its content may not be used to construct a database of any kind nor may the same be stored (in whole or part) in databases for access by you or any third party or to distribute any database containing all or part of the application or its content.</p>
        <h4>Other terms and notices may apply</h4>
        <p>Additional terms and conditions will apply to business transactions conducted or any promotions run by 3M via this application. Additional terms will govern any bulletin board services, chat areas and or other message or communication facilities offered via this application. Nothing contained in this legal information page is intended to modify or amend any agreement currently in effect between you and 3M.Although these terms of use are intended to apply generally to all content located under 3m.ca, this application may contain other proprietary notices and conditions of use, the terms of which must also be observed and followed as they apply to the particular portions of this application for which they are intended. Certain portions of this application are intended for audiences in specific countries as indicated by specific country references in the application page header information (for instance, "3M United States," "3M United Kingdom," or "3M Canada"). Terms of use for country specific application pages may vary and can be accessed from the 3M application for that specific country. 3M may revoke or modify any of the rights stated in this legal information page at any time by updating this page.</p>
        <h4>Other intellectual property rights</h4>
        <p>Please note that any product, process or technology described in the materials on this application may be the subject of other intellectual property rights reserved by 3M and are not licensed hereunder. 3M and the 3M logo are the worldwide trademarks or registered trademarks of 3M. Trademarks of other parties are identified wherever possible and 3M acknowledges their rights.<br />U.S. government usersUse, duplication, or disclosure by the United States government are subject to the restrictions set forth in DFARS 252.227-7013(c)(1)(ii) and FAR 52.227-19 and any other successor regulations that may be applicable.</p>
        <h4>Disclaimers</h4>
        <p>3M and the 3M logo are trademarks or registered trademarks of 3M, used under license in Canada. All other product names mentioned herein are the trademarks of their respective owners.THE INFORMATION CONTAINED IN THIS application IS PROVIDED TO YOU "AS IS," FOR YOUR INFORMATIONAL PURPOSES ONLY, WITHOUT WARRANTY OR CONDITION OF ANY KIND, INCLUDING ANY IMPLIED WARRANTY OR CONDITION OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF IMPLIED WARRANTIES, SO THE ABOVE EXCLUSION MAY NOT APPLY TO YOU. This information could contain technical inaccuracies or typographical errors, and information will be changed, updated and deleted without notice. 3M may make improvements and/or changes in the products and/or the programs described in this material at any time.Additionally, 3M makes no representations or warranties whatsoever about any other application which you may choose to access through this application. Links provided by 3M to such applications are provided solely for your convenience and should not be deemed to imply that 3M endorses those applications or any content therein. IN NO EVENT WILL 3M BE LIABLE TO ANY PARTY FOR ANY DIRECT, INDIRECT, SPECIAL OR OTHER TYPES OF CONSEQUENTIAL DAMAGES FOR USE OF THIS application OR ANY OTHER HYPERLINKED application INCLUDING SPECIFICALLY, BUT NOT EXCLUSIVELY, ANY LOST PROFITS, BUSINESS INTERRUPTION, OR LOSS OF DATA, EVEN IF 3M IS EXPRESSLY ADVISED ABOUT THE POSSIBILITY OF SUCH DAMAGES.</p>
        <h4>Submitting information to 3M</h4>
        <p>Please see our&nbsp;Privacy Policy&nbsp;for general information. 3M does not want to receive confidential or proprietary information from you through its application. Any information that 3M receives through its application, other than your personally identifiable information, as explained in 3M's Privacy Policy, will be deemed to be non-confidential. By transmitting to 3M information via this application or otherwise through electronic means, you grant to 3M an unrestricted, irrevocable license to use, reproduce, display, modify, perform and distribute such information, and 3M is free to use the information, including any ideas, know-how or techniques contained therein free of charge for any purpose whatsoever.This application may contain other proprietary notices and conditions of use, the terms of which must also be observed and followed.</p>`,

    },
    landing: {
        beginbutton: 'Click here to continue',
        start: 'Start Course',
        termtitle: '',
        clickterms: 'Terms and Conditions',
        metatitle: 'Safety Training Instructor Training Portal',
        metadescription: '',
        auth: 'Instructor',
        topics: 'Topics',
        courses: 'Courses',
        options: 'Options',
        present: 'Presentation',
        pin:'Please enter your Instructor Number',
        welcome: 'Welcome',
        canada:'Canada',
        usa:'United States',
        french:'French',
        english:'English',
        day:'Day',
        chooselanguage: 'Choose your language',
        chooseprovince: 'Choose your province',
        choosecountry: 'Choose your country',
        trainingday: 'Choose your training day',
        offexpirydesc: ' An active internet connection is required to reauthenticate your activation before this date.',
        offexpiry: 'Offline Expiry',
        certexpirydesc: 'Your certification to instruct one or more courses is set to expire on this date. Manage your presentations to find more information on each course. Please contact 3M Safety Training to get recertified.',
        certexpiry: 'Next Certificate Expiry',
        selectcourse:'Please select a course topic'
    },
    login:{
        logindescription: 'Please login to continue.',
        youremail: 'Your Email',
        yourpass: 'Your Password',
        login: 'Login'
    },
    rebate:{
      requiredfield: 'This field is required',
      invalidemail: 'Your email looks wrong'
    }
    }
   
};

// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: 'en', // set locale
    messages, // set locale messages

});

Vue.prototype.i18n = i18n;

Vue.use(Vuelidate);
Vue.use(Vuetify);
Vue.use(VueAxios, axios);
Vue.use(BootstrapVue);

Vue.config.productionTip = false;
Vue.prototype.api = "https://instructor.branton.io";
// Vue.prototype.api = 'http://192.168.4.39:8888/mmm-safetytraining';
Vue.prototype.$axios = axios;
Vue.prototype.isLoggedIn = false;
Vue.prototype.user = [];
Vue.prototype.presentation = {};

// router.beforeEach(
//     (to,from, next) => {
//         if (to.matched.some(record => record.meta.requiresAuth)) {
//             if(Vue.auth.isAuthenticated()){
//                 next({
//                     path: '/login',
//                 })
//             } else {
//                 next();
//             }
//         }

//       }sudo
//   )

//Make a global check for expiry date and jwt. If expired then delete.
//Also make submission bilinigual functionality
//Then done.
router.beforeEach(
    (to,from, next) => {
        
        let language = to.params.lang;
        if (!language) {
          language = 'en';
        //  window.location.href = '/';
        } 

        if(language == 'fr') {
            moment.locale('fr');
        } else {
            moment.locale('en');
        }

        i18n._vm.locale = language;

      if(to.matched.some(record => record.meta.requiresAuth)){
        let now = new Date().getTime();
        if((!Vue.prototype.$session.has("jwt") && ! Vue.prototype.$session.get('expiry')) || ( now > new Date(Vue.prototype.$session.get('expiry')).getTime())){
            Vue.prototype.$session.clear();
            router.app.$root.isLoggedIn = false;
            router.app.$root.user = [];
            router.app.$root.presentation = {};
          next({
            path: language+'/login'
          });
  
        } else {
            router.app.isLoggedIn = true;
          next();
  
        }
      } else {
        next();
      }
    }
  );

new Vue({
    data:{
        isLoggedIn: false,
        user: [],
        presentation: {}
    },
    i18n,
    router,
    store,
    pinia,
    render: h => h(App)
}).$mount('#app');